import { PollNode } from "./poll-node";

import type { LexicalNode } from "lexical";

export function $isPollNode(node: LexicalNode | null | undefined): node is PollNode {
  return node instanceof PollNode;
}
